module.exports = __webpack_public_path__ + "static/img/m_name.731dbfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/kr/m_name.png
// module id = nCWF
// module chunks = 7